module.exports = __webpack_public_path__ + "images/file_icons_v2/tif-f23e00ac6bf38e833ffe51057c362c9b.svg";